/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import { Checkbox, Modal } from "antd";
// import { ReactComponent as CommentDotsIcon } from "assets/mobile/icons/comment-dots-solid.svg";
// import { ReactComponent as ArrowNextIcon } from "assets/mobile/icons/return-up-next.svg";
import Loading from "components/common/Loading";
import { ModalTypeValue } from "enums/modalType";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
// import _map from "lodash/map";
import { selectAllAnnouncement, selectIsLoading } from "store/announcement";
import { selectOpenSubModal, setOpenSubModal } from "store/master";

// import { AnnouncementItemType } from "types/announcement";
// import MobileNotificationDetail from "./MobileNotificationDetail";
import { ModalMobileNotificationStyle } from "./style.index";

const ModalMobileNotification = () => {
  const dispatch = useAppDispatch();
  const openModal = useAppSelector(selectOpenSubModal);

  // const [notificationList, setNotificationList] = useState<
  //   AnnouncementItemType[] | null
  // >(null);
  const notificationList = useAppSelector(selectAllAnnouncement);
  const isLoading = useAppSelector(selectIsLoading);
  // const [notificationSelected, setNotificationSelected] =
  //   useState<AnnouncementItemType | null>(null);
  // const [isLoading, setIsLoading] = useState<boolean>(false);

  // const handleSelectNotification = (notification: AnnouncementItemType) => {
  //   setNotificationSelected(notification);
  // };

  // const getData = async () => {
  //   try {
  //     setIsLoading(true);
  //     const { data } = await AnnouncementApi.getAnnouncement({ type: 1 });
  //     if (data.status === ResponseCode.SUCCESS) {
  //       setNotificationList(data.data);
  //     }
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   getData();
  // }, []);

  return (
    <>
      <Modal
        title="THÔNG BÁO MỚI"
        open={openModal === ModalTypeValue.MOBILE_NEWS}
        onCancel={() => dispatch(setOpenSubModal(ModalTypeValue.CLOSE))}
        css={ModalMobileNotificationStyle.wrapper}
        footer={
          <div css={ModalMobileNotificationStyle.close}>
            <div css={ModalMobileNotificationStyle.label}>
              <span
                onClick={() => dispatch(setOpenSubModal(ModalTypeValue.CLOSE))}
              >
                Đóng
              </span>
            </div>
            <div css={ModalMobileNotificationStyle.checkBox}>
              <Checkbox /> không hiển thị nữa
            </div>
          </div>
        }
      >
        <div css={ModalMobileNotificationStyle.mainContent}>
          {isLoading ? (
            <Loading height={300} center />
          ) : (
            // <ul css={ModalMobileNotificationStyle.listNotification}>
            //   {_map(notificationList, (item, index) => (
            //     <li
            //       key={index}
            //       css={ModalMobileNotificationStyle.notificationItem}
            //       onClick={() => handleSelectNotification(item)}
            //     >
            //       <div css={ModalMobileNotificationStyle.itemTitleWrapper}>
            //         <CommentDotsIcon className="iconCommentDot" />
            //         <span css={ModalMobileNotificationStyle.itemTitle}>
            //           {item.title}
            //         </span>
            //       </div>
            //       <ArrowNextIcon
            //         css={ModalMobileNotificationStyle.arrowNextIcon}
            //       />
            //     </li>
            //   ))}
            // </ul>
            <>
              {notificationList.length > 0 ? (
                <div
                  css={css`
                    padding-top: 2px;
                    img {
                      width: 100% !important;
                    }
                    p {
                      font-size: 14px !important;
                      line-height: 1.6;
                    }
                  `}
                  dangerouslySetInnerHTML={{
                    __html: notificationList[0].content,
                  }}
                />
              ) : (
                <div
                  css={css`
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    p {
                      font-size: 14px !important;
                      line-height: 1.6;
                    }
                  `}
                >
                  No data
                </div>
              )}
            </>
          )}
        </div>
      </Modal>
      {/* <MobileNotificationDetail
        data={notificationSelected}
        onBack={() => setNotificationSelected(null)}
      /> */}
    </>
  );
};

export default ModalMobileNotification;
